export const getVisitorId = () => {
  let visitorId = localStorage.getItem('visitor_id');

  if (!visitorId) {
    visitorId = crypto.randomUUID();
    localStorage.setItem('visitor_id', visitorId);
  }

  console.log("VISITOR ID CREATED/FOUND:", visitorId);
  return visitorId;
};